import type { FC } from 'react';
import React from 'react';

import { PARAM_NAME, PERCENT_NAME, SEPARATOR } from '../../config';

import type { TSlogan } from './models';

export const Slogan: FC<TSlogan> = props => {
    const { Text, initValue = 0, maxValue, progressBarFilledValue, slogan, sloganPostfix } = props;

    // Если есть частичное заполнение прогресс-бара
    if (progressBarFilledValue && progressBarFilledValue > initValue) {
        const postfixArray = sloganPostfix.split(SEPARATOR);
        const hasBindPercent = postfixArray.indexOf(PERCENT_NAME);

        postfixArray.splice(hasBindPercent, 1, progressBarFilledValue.toString());

        // Если в строке есть шаблон для процентов
        if (hasBindPercent !== -1) {
            return <>{postfixArray}</>;
        }

        // Иначе показать процент заполнения в начале
        return (
            <>
                <Text fontWeight={6} tag="span">
                    {progressBarFilledValue}%{' '}
                </Text>
                {sloganPostfix ? <span>{sloganPostfix}</span> : null}
            </>
        );
    }

    // Иначе показать текст со вставкой макс. значения
    const resultArray: Array<string | JSX.Element> = slogan.split(SEPARATOR);
    const percentages = (
        <Text key={maxValue} fontSize={14} fontWeight={6} tag="span">
            +{maxValue}%
        </Text>
    );

    resultArray.splice(resultArray.indexOf(PARAM_NAME), 1, percentages);

    return <>{resultArray}</>;
};
